'use client';
export const getGa4ClientId = (): string => {
  const gaCookie = (document.cookie || '')
    .split('; ')
    .find((row) => row.startsWith('_ga='));
  if (gaCookie) {
    const parts = gaCookie.split('.');
    return parts.length > 2 ? parts[2] + '.' + parts[3] : '';
  }
  return '';
};
